export class Chapter {

    public id: number;
    public title: string;

    public static createMany(data: any[]): Chapter[] {
        let chapters: Chapter[] = [];
        for (let item of data) {
            chapters.push(Chapter.createOne(item));
        }
        return chapters;
    }

    public static createOne(data: any): Chapter {
        let chapter = new Chapter();
        chapter.fill(data);
        return chapter;
    }

    public fill(data: any) {
        this.id = data.id || null;
        this.title = data.title || null;
    }

}



// WEBPACK FOOTER //
// ./src/models/Chapter.ts